<template>
	<div>
		<bv-top></bv-top>

    <van-cell-group>
      <van-cell title="机构:" :value="item.branch" value-class="van-cell_value"/>
      <van-cell title="网点名称:" :value="item.branchName" value-class="van-cell_value" />
      <van-cell title="电话:" :value="item.phoneNo"  value-class="van-cell_value"/>
      <van-cell title="地址:" :value="item.branchAddress" value-class="van-cell_value" />
    </van-cell-group>
	</div>
</template>

<script>


	import Top from '@/views/components/Top'

	export default {
		name: 'BranchInfo',
		components: {
			BvTop:Top,
		},
		data() {
			return {
				smallLogo: require('@/assets/small-logo.png'),
				label: decodeURIComponent(this.$route.query.label),
        value: this.$route.query.value,
				item: this.$route.query.item,
			}
		},
		methods: {

		},
		mounted() {

		}
	}
</script>
<style>
	p img {
		width: 94vw;
		margin-left: 3vw;
	}
  .van-cell_value {
    min-width: 80%;
    display: inline-block;
    text-align: left;
    word-break: break-all;
   }
  .van-cell_span {

  }


</style>